"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _awsAmplify = require("aws-amplify");

var _reactRouterDom = require("react-router-dom");

var _default = function _default() {
  // Cache.clear();
  var location = (0, _reactRouterDom.useLocation)();
  var pathname = location.pathname.split("/").filter(function (piece) {
    return piece.length <= 30;
  }).join("/");
  var hasVisitedPage = !!_awsAmplify.Cache.getItem(pathname);
  !hasVisitedPage && _awsAmplify.Cache.setItem(pathname, true);
  return hasVisitedPage;
};

exports["default"] = _default;